import request from './request';

export default {
	async getHkustPoints(query) {
		const res = await request.get('/app/hkust-points', query);
		return res;
	}
};
